import { createContext, useContext, useState, type ReactNode } from "react";

interface NotificationPanelContextValue {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

const NotificationPanelContext = createContext<NotificationPanelContextValue | null>(null);

export function NotificationPanelProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  return (
    <NotificationPanelContext.Provider
      value={{ open, setOpen, toggle: () => setOpen(!open) }}
    >
      {children}
    </NotificationPanelContext.Provider>
  );
}

export function useNotificationPanel() {
  const ctx = useContext(NotificationPanelContext);
  if (!ctx) throw new Error("useNotificationPanel must be used within NotificationPanelProvider");
  return ctx;
}